/**
 * Guía: Estadísticas.
 *
 * Contenido derivado del capítulo **34** del manual: §0 (un panel de lectura
 * cuya cifra de ingresos no significaba lo mismo que la del panel
 * financiero) y §1 (quién entra).
 *
 * El paso central es el que evita la contradicción entre paneles: aquí se
 * mira actividad, no dinero de cierre. Un panel que contradice a otro es un
 * panel del que nadie se fía.
 */

import type { TourFlow } from '../types';

const ESTADISTICAS_PATH = '/statistics';

export const c34Estadisticas: TourFlow = {
  id: 'admin.statistics',
  chapter: '34',
  title: 'Estadísticas',
  summary:
    'Actividad del país: qué mide cada cifra y por qué no se compara con el panel financiero.',
  href: ESTADISTICAS_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Un panel de lectura, sin acciones',
      body:
        'Agrega pedidos, clientes, promociones y publicidad de un periodo y los pinta. No ' +
        'escribe nada y no mueve dinero: el riesgo aquí no es romper algo, es leer un ' +
        'número que describe otro conjunto.',
      route: ESTADISTICAS_PATH,
    },
    {
      id: 'not-the-finance-panel',
      title: 'No se compara con el panel financiero',
      body:
        'Miden cosas distintas para el mismo país y el mismo periodo, y por eso dan ' +
        'distinto. Para hablar de dinero, el panel financiero y los informes; esto es ' +
        'actividad.',
      target: 'admin.statistics.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'period',
      title: 'El periodo manda sobre todo lo que ves',
      body:
        'Todas las cifras cuelgan del rango elegido, resuelto en la zona horaria del país. ' +
        'Antes de sacar una conclusión —o de pegar un número en un correo— conviene decir ' +
        'de qué periodo es.',
    },
    {
      id: 'country-scope',
      title: 'Del país seleccionado',
      body:
        'Como el resto de la sección de país. Un dato que no cuadra con lo que recuerdas ' +
        'suele ser el país o el rango, en ese orden.',
    },
  ],
};
